export default function getAddress(data, addName = null) {
  let address = '';
  if (addName) {
    address += `${data.name}, `;
  }
  if (data.address) {
    address += data.address;
  }
  if (data.city) {
    address += `, ${data.city}`;
  }
  if (data.state) {
    address += `, ${data.state}`;
  }
  if (data.country) {
    address += `, ${data.country}`;
  }
  if (data.pincode) {
    address += ` - ${data.pincode}`;
  }
  return address;
}
